
import { getPath } from '@/router/common'

const baseUrl = {
  title: '车队报账',
  path: 'CheckSheet'
}
export default [
  {
    path: getPath('Main', baseUrl),
    name: 'CheckSheetMain',
    component: () => import(/* webpackChunkName: "Main" */ '@/views/checkSheet/main/index.vue'),
    meta: {
      title: '合同主体'
    }
  },
  {
    path: getPath('DriverFees', baseUrl),
    name: 'DriverFees',
    component: () => import(/* webpackChunkName: "DriverFees" */ '@/views/checkSheet/driverFees/index.vue'),
    meta: {
      title: '司机费用'
    }
  },
  {
    path: getPath('ExpensesAlongTheWay', baseUrl),
    name: 'ExpensesAlongTheWay',
    component: () => import(/* webpackChunkName: "ExpensesAlongTheWay" */ '@/views/checkSheet/expensesAlongTheWay/index.vue'),
    meta: {
      title: '沿途费用'
    }
  },
  {
    path: getPath('OilCardFees', baseUrl),
    name: 'OilCardFees',
    component: () => import(/* webpackChunkName: "OilCardFees" */ '@/views/checkSheet/oilCardFees/index.vue'),
    meta: {
      title: '油卡费用'
    }
  },
  {
    path: getPath('ReturnCargo', baseUrl),
    name: 'ReturnCargo',
    component: () => import(/* webpackChunkName: "ReturnCargo" */ '@/views/checkSheet/returnCargo/index.vue'),
    meta: {
      title: '返程货物'
    }
  },
  {
    path: getPath('DepartureList', baseUrl),
    name: 'DepartureList',
    component: () => import(/* webpackChunkName: "DepartureList" */ '@/views/checkSheet/departureList/index.vue'),
    meta: {
      title: '发车清单'
    }
  },
  {
    path: getPath('FleetHome', baseUrl),
    name: 'FleetHome',
    component: () => import(/* webpackChunkName: "FleetHome" */ '@/views/checkSheet/fleetHome/index.vue'),
    meta: {
      title: '车队报账单'
    }
  },
  {
    path: getPath('FleetInfo', baseUrl),
    name: 'FleetInfo',
    component: () => import(/* webpackChunkName: "FleetInfo" */ '@/views/checkSheet/fleetInfo/index.vue'),
    meta: {
      title: '报账单统计表'
    }
  },
  {
    path: getPath('FleetIndex', baseUrl),
    name: 'FleetIndex',
    component: () => import(/* webpackChunkName: "FleetIndex" */ '@/views/checkSheet/fleetIndex/index.vue'),
    meta: {
      title: '车队报账'
    }
  },
  {
    path: getPath('FleetCheckSheet', baseUrl),
    name: 'FleetCheckSheet',
    component: () => import(/* webpackChunkName: "FleetCheckSheet" */ '@/views/checkSheet/fleetCheckSheet/index.vue'),
    meta: {
      title: '新增编辑车队报账单'
    }
  }
]
